import { render, staticRenderFns } from "./MyFavourites.vue?vue&type=template&id=74732212&scoped=true"
import script from "./MyFavourites.vue?vue&type=script&lang=ts"
export * from "./MyFavourites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74732212",
  null
  
)

export default component.exports